import { render, staticRenderFns } from "./FileSystem.vue?vue&type=template&id=84eaabe4&scoped=true&"
import script from "./FileSystem.vue?vue&type=script&lang=ts&"
export * from "./FileSystem.vue?vue&type=script&lang=ts&"
import style0 from "./FileSystem.vue?vue&type=style&index=0&id=84eaabe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84eaabe4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
